import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.4; transform: scale(0.85); }
`

export const ConversationStreamListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space.xlarge};
  overflow-y: auto;
`

export const ConversationStreamItemStyled = styled.div<{
  $isUserTurn: boolean
}>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space.medium};
  margin: ${(props) =>
    props.$isUserTurn ? `${props.theme.space.medium} 0` : 0};

  &:first-child {
    margin-top: 0;
  }

  &:empty {
    display: none;
  }
`

export const ConversationComponentSlotStyled = styled.div<{
  $isSectionStart: boolean
}>`
  margin-top: ${(props) =>
    props.$isSectionStart ? props.theme.space.medium : 0};
`

export const ConversationProgressStubStyled = styled.div<{
  $isAfterResponse: boolean
}>`
  align-self: flex-start;
  margin-top: ${(props) =>
    props.$isAfterResponse ? props.theme.space.medium : 0};
  color: ${(props) => props.theme.colors.text.tertiary};
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
`

export const ConversationThinkingSparkleStyled = styled.span`
  display: inline-flex;
  animation: ${pulse} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`
